import React from "react"
import get from 'lodash/get'
import set from 'lodash/set'
import clone from 'lodash/clone'
import moment from '../../../lib/moment.js'
import axios from 'axios'
import { BASE_URL } from '../../../constants'
import Searchbar from '../searchbar/searchbar-attachment'
import AttachmentTable from '../table/table-attachment'
import { addButton } from '../helper/button'
import { ConfirmSaveForm, AddAttachmentForm } from '../form'

export default class AttachmentTab extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'projectByID')
    && JSON.stringify(get(nextProps, 'projectByID')) !== JSON.stringify(prevState.projectByID)
    ) {
      const projectByID = get(nextProps, 'projectByID')
      set(tempState, 'projectByID', projectByID)
      set(tempState, 'attachments', projectByID.attachments)
    }
    if (get(nextProps, 'editAttachment') !== get(prevState, 'editAttachment')) {
      set(tempState, 'editAttachment', get(nextProps, 'editAttachment'))
    }
    return tempState
  }

  state={
    editAttachment: false,
    showAddAttachment: false,
    attachments: [],
    search_attach: '',
    attachment_loading: false,
    attachment_name: '',
    attachment_description: '',
    attachment_url: '',
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)
    && JSON.stringify(this.state) === JSON.stringify(nextState)) return false
    return true
  }

  addAttachment = () => {
    const oldAttachments = this.state.attachments
    const attachment = {}
    let attachments = []
    attachment.name = this.state.attachment_name
    attachment.url = this.state.attachment_url
    attachment.description = this.state.attachment_description
    attachment.created = moment().format('YYYY-MM-DD')
    attachment.created_by = get(this.props, 'id')
    attachments = [...oldAttachments, attachment]
    this.setState({
      attachment_name: '',
      attachment_description: '',
      attachments,
      showAddAttachment: !this.state.showAddAttachment,
    })
  }

  confirmEditAttachment = () => {
    const editProjectInformation = get(this.props, 'editProjectInformation')
    const payload = clone(this.state.projectByID)
    delete payload.project_type
    delete payload.created
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload._id
    delete payload.updated_by
    payload.attachments = this.state.attachments
    editProjectInformation(payload)
    this.setState({ showConfirmSave: !this.state.showConfirmSave })
    get(this.props, 'clickEditAttachment')()
  }

  clickAddAttachment = () => {
    this.setState({
      showAddAttachment: !this.state.showAddAttachment,
      attachment_loading: false,
      attachment_name: '',
      attachment_description: '',
      attachment_url: '',
    })
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleChangeCost = (e) => {
    const newAttchments = this.state.attachments
    const attachment = this.state.attachments[e.target.id]
    const field = e.target.name
    attachment[field] = e.target.value
    attachment.created = moment().format('YYYY-MM-DD')
    attachment.created_by = get(this.props, 'id')
    newAttchments[e.target.id] = attachment
    this.setState({ attachments: newAttchments })
  }

  deleteAttachment= (id) => {
    const attachments = clone(this.state.attachments)
    attachments.splice(id, 1)
    this.setState({ attachments })
  }

  uploadFile = async (e) => {
    const showConfirm = get(this.props, 'showConfirm')
    if (e.target.files.length === 0) return
    this.setState({ attachment_loading: true })
    const file = e.target.files[0]
    const name = e.target.files[0].name
    const data = new FormData()
    data.set('file', file)
    let attachment_url = ''
    let attachment_name = ''

    try {
      const resp = await axios({
        method: 'post',
        url: `${BASE_URL}/upload/attachment`,
        headers: {
          'authorization': `bearer ${localStorage.getItem('access_token')}`,
        },
        data,
      })
      if (resp.status === 200) {
        attachment_url = resp.data.fileResult.Location
        attachment_name = name
      }
    } catch (error) {
      // const res = error.response.data
      showConfirm('uploadFail', 'Error', 'The file you uploaded exceeds 5 MB.')
    } finally {
      this.setState({
        attachment_loading: false,
        attachment_url,
        attachment_name,
      })
    }
  }

  removeFile = () => {
    this.setState({
      attachment_url: null,
      attachment_name: '',
    })
  }

  /* eslint no-underscore-dangle: 0 */
  render() {
    const { hideHeader } = this.props
    const getProjectInformationByID = get(this.props, 'getProjectInformationByID')
    const clickEditAttachment = get(this.props, 'clickEditAttachment')
    return (
      <div>
        <AddAttachmentForm
          open={ this.state.showAddAttachment }
          button={
            addButton(
              'uploadAttachment',
              () => this.addAttachment(),
              () => this.setState({ showAddAttachment: !this.state.showAddAttachment }),
              this.state.attachment_name === ''
            ) }
          handleInput={ this.handleInput }
          uploadFile={ this.uploadFile }
          removeFile={ this.removeFile }
          attachment_loading={ this.state.attachment_loading }
          attachment_name={ this.state.attachment_name }
          attachment_url={ this.state.attachment_url }
          toggle={ () => this.setState({ showAddAttachment: !this.state.showAddAttachment }) }
        />
        <ConfirmSaveForm
          open={ this.state.showConfirmSave }
          toggle={ () => this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          confirmSave={ this.confirmEditAttachment }
        />
        <Searchbar
          editAttachment={ this.state.editAttachment }
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          clickEdit={ () => clickEditAttachment() }
          clickAddAttachment={ () => this.clickAddAttachment() }
          confirmEditAttachment={ () =>
            this.setState({ showConfirmSave: !this.state.showConfirmSave }) }
          cancelEdit={ () => {
            clickEditAttachment()
            this.setState({ projectByID: null })
            getProjectInformationByID()
          } }
        />
        <AttachmentTable
          hideHeader={ hideHeader }
          projectByID={ get(this.props, 'projectByID') }
          rSelected={ get(this.props, 'rSelected') }
          editAttachment={ this.state.editAttachment }
          search_attach={ this.state.search_attach }
          attachments={ this.state.attachments }
          deleteAttachment={ this.deleteAttachment }
          handleChangeCost={ this.handleChangeCost }
          employees={ get(this.props, 'employees') }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-attachment.js